var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('form',[_c('string-form-field',{attrs:{"label":"Titolo","value":_vm.value.title,"disabled":_vm.disabled,"error":_vm.findError('title')},on:{"input":function($event){return _vm.propertyChanged('title', $event)}}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }